import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const ADD_ABOUTUS = "create";
const DELETE_ABOUTUS = "delete";
const GET_ABOUTUS = "get";
const EDIT_ABOUTUS = "edit";

export default {
  createAboutUs(payload) {
    return Repository.post(transformRoute(ADD_ABOUTUS), payload);
  },
  deleteAboutUs(payload) {
    return Repository.post(transformRoute(DELETE_ABOUTUS), payload);
  },
  getAboutUs(payload) {
    return Repository.post(transformRoute(GET_ABOUTUS), payload);
  },
  editAboutUs(payload) {
    return Repository.post(transformRoute(EDIT_ABOUTUS), payload);
  },
};

const transformRoute = (route) => {
  return `cms/aboutUs/${route}`;
};
